import React from 'react';
import { FiHome, FiInstagram, FiFacebook, FiTwitter, FiLinkedin } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-slate-950 text-slate-400 py-12 border-t border-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8 pb-8 border-b border-slate-800">
          
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center text-white mb-4">
              <SafeIcon icon={FiHome} className="text-2xl mr-2 text-amber-500" />
              <span className="font-bold text-xl tracking-tight">
                STERLING <span className="font-light">ESTATES</span>
              </span>
            </div>
            <p className="max-w-sm text-sm leading-relaxed">
              Redefining luxury real estate with an unparalleled commitment to excellence, integrity, and personalized service.
            </p>
            <div className="flex space-x-4 mt-6">
              {[FiInstagram, FiFacebook, FiTwitter, FiLinkedin].map((Icon, i) => (
                <a key={i} href="#" className="w-10 h-10 rounded-full bg-slate-900 flex items-center justify-center hover:bg-amber-600 hover:text-white transition-colors duration-300">
                  <SafeIcon icon={Icon} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 tracking-wide uppercase text-sm">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#home" className="hover:text-amber-500 transition-colors">Home</a></li>
              <li><a href="#about" className="hover:text-amber-500 transition-colors">About Eleanor</a></li>
              <li><a href="#listings" className="hover:text-amber-500 transition-colors">Featured Properties</a></li>
              <li><a href="#testimonials" className="hover:text-amber-500 transition-colors">Client Reviews</a></li>
              <li><a href="#contact" className="hover:text-amber-500 transition-colors">Contact</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 tracking-wide uppercase text-sm">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="hover:text-white transition-colors">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Terms of Service</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Cookie Policy</a></li>
              <li><a href="#" className="hover:text-white transition-colors">Fair Housing</a></li>
            </ul>
          </div>

        </div>
        
        <div className="flex flex-col md:flex-row justify-between items-center text-xs">
          <p>&copy; {new Date().getFullYear()} Sterling Estates Real Estate. All rights reserved.</p>
          <p className="mt-2 md:mt-0">Designed elegantly for premium experiences.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;